import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const OrderGate = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="OrderGate" {...rest}>
      <g clipPath="url(#clip0)">
        <path
          d="M8.22998 14V9.5V9V8L5.22998 9V10.5L6.72998 10V14H5.72998V15.5H9.22998V14H8.22998Z"
          fill="currentColor"
        />
        <path
          d="M15.9402 12.47L17.6702 15.77L18.2902 15.14L17.3502 11.06"
          fill="currentColor"
        />
        <path
          d="M13.2801 13L11.9401 12.81L11.3601 13.39L13.0901 14.39L14.0901 16.12L14.6701 15.54L14.4801 14.2"
          fill="currentColor"
        />
        <path
          d="M16.4102 10.12L12.3302 9.17001L11.7002 9.80001L15.0002 11.53"
          fill="currentColor"
        />
        <path
          d="M14.23 13.23L18.73 8.73001"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M22 5V18H2V5H22ZM22 3H2C1.46957 3 0.960859 3.21071 0.585786 3.58579C0.210714 3.96086 0 4.46957 0 5L0 18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H22C22.5304 20 23.0391 19.7893 23.4142 19.4142C23.7893 19.0391 24 18.5304 24 18V5C24 4.46957 23.7893 3.96086 23.4142 3.58579C23.0391 3.21071 22.5304 3 22 3Z"
          fill="currentColor"
        />
        <path
          d="M5 0C4.73478 0 4.48043 0.105357 4.29289 0.292893C4.10536 0.48043 4 0.734784 4 1V6C4 6.26522 4.10536 6.51957 4.29289 6.70711C4.48043 6.89464 4.73478 7 5 7C5.26522 7 5.51957 6.89464 5.70711 6.70711C5.89464 6.51957 6 6.26522 6 6V1C6 0.734784 5.89464 0.48043 5.70711 0.292893C5.51957 0.105357 5.26522 0 5 0V0Z"
          fill="currentColor"
        />
        <path
          d="M19 0C18.7348 0 18.4804 0.105357 18.2929 0.292893C18.1054 0.48043 18 0.734784 18 1V6C18 6.26522 18.1054 6.51957 18.2929 6.70711C18.4804 6.89464 18.7348 7 19 7C19.2652 7 19.5196 6.89464 19.7071 6.70711C19.8946 6.51957 20 6.26522 20 6V1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0V0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
